import axios from 'axios';
import { Person } from '../types/person';
// import { PaginatedResponse } from '../types/api'; // Comentar ou remover se api.ts não existe

interface PaginatedResponse<T> {
  data: T[];
  totalCount: number;
}

export interface PersonFilter {
  name?: string;
  email?: string;
  cpf?: string;
  active?: boolean;
  service_provider?: boolean;
  hr?: boolean;
  prestador_servico?: boolean;
  page?: number;
  pageSize?: number;
  sortField?: string;
  sortOrder?: 'asc' | 'desc';
}

// Usar variável de ambiente
const API_BASE_URL = `${import.meta.env.VITE_API_BASE_URL}/api`;
const PERSONS_ENDPOINT = '/persons';

export class PersonService {
  async getAll(filters?: PersonFilter): Promise<PaginatedResponse<Person>> {
    try {
      // Usar a URL completa
      const response = await axios.get<PaginatedResponse<Person>>(`${API_BASE_URL}${PERSONS_ENDPOINT}`, { params: filters });
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar pessoas:", error);
      throw error;
    }
  }

  async getById(id: number): Promise<Person> {
    // Usar a URL completa
    const response = await axios.get<Person>(`${API_BASE_URL}${PERSONS_ENDPOINT}/${id}`);
    return response.data;
  }

  async create(person: Omit<Person, 'id' | 'createdAt' | 'updatedAt' | 'profile'>): Promise<Person> {
    // Usar a URL completa
    const response = await axios.post<Person>(`${API_BASE_URL}${PERSONS_ENDPOINT}`, person);
    return response.data;
  }

  async update(id: number, person: Partial<Omit<Person, 'id' | 'createdAt' | 'updatedAt' | 'profile'>>): Promise<Person> {
    // Usar a URL completa
    const response = await axios.put<Person>(`${API_BASE_URL}${PERSONS_ENDPOINT}/${id}`, person);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    // Usar a URL completa
    await axios.delete(`${API_BASE_URL}${PERSONS_ENDPOINT}/${id}`);
  }
} 